/**
 * The admin's remembered clinic. Kept apart from the provider so the logout
 * path in services/auth can forget it without importing React context (and
 * without closing an import cycle through apiClient → tokenManager → auth).
 * Storage can be blocked, full or absent, so every call shrugs on failure.
 */
export const SELECTED_CLINIC_KEY = "selected_clinic_id";

export function readSelectedClinic() {
  try {
    return localStorage.getItem(SELECTED_CLINIC_KEY) || null;
  } catch {
    return null;
  }
}

export function storeSelectedClinic(id) {
  try {
    if (id) localStorage.setItem(SELECTED_CLINIC_KEY, id);
    else localStorage.removeItem(SELECTED_CLINIC_KEY);
  } catch {
    // Not remembering the choice is a shrug, not a failure.
  }
}

export function clearSelectedClinic() {
  try {
    localStorage.removeItem(SELECTED_CLINIC_KEY);
  } catch {
    // Forgetting nothing is harmless.
  }
}
